import * as React from 'react';
import './InnerUiWrap.scss';

export interface IProps {
}

export interface IFunctions {
}

export type IAllProps = IProps & IFunctions;

export const InnerUiWrap: React.SFC<IAllProps> = ({children}) =>
    <div className="InnerUiWrap-wrap">
        {children}
    </div>;

export default InnerUiWrap;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/inner-ui-wrap/InnerUiWrap.tsx